import ApiService from './../api/ApiService';
import Urls from './../api/Urls';
import HomestayRoomType from './../models/HomestayRoomType';
import { getDummyData } from './../utils/commonUtils';
import Config from "./../constants/Config"
import { omit } from 'lodash';

export function getHomestayRoomTypes(params) {
    return new ApiService({
        endpoint: params.homestay_id || params.homestayId ? Urls.HOMESTAY_ROOM_TYPE_LIST_BY_HOTEL_ID : Urls.HOMESTAY_ROOM_TYPE_LIST,
        baseURL: Config.API_HOMESTAY,
        params: omit(params, ['homestay_id', 'homestayId']),
        endpointParams: params.homestay_id || params.homestayId ? { id: params.homestay_id || params.homestayId } : undefined,
        parser: dataParser,
    }).get();
}

export function getHomestayRoomTypesByHotel(params) {
    return new ApiService({
        endpoint: Urls.HOMESTAY_ROOM_TYPE_LIST_BY_HOTEL_ID,
        baseURL: Config.API_HOMESTAY,
        params: params,
        endpointParams: { id: params.homestay_id || params.homestayId },
        parser: dataParser,
    }).get();
}

export function getHomestayRoomType(id) {
    return new ApiService({
        endpoint: `${Urls.HOMESTAY_ROOM_TYPE_DETAIL}/${id}`,
        baseURL: Config.API_HOMESTAY,
        parser: dataItemParserDetail,
    }).get();
}

export function saveHomestayRoomType(HomestayRoomType) {
    HomestayRoomType.features = []; // NEED EDIT WHEN CONFIRM feature
    return HomestayRoomType.id ? new ApiService({
        endpoint: `${Urls.HOMESTAY_ROOM_TYPE_UPDATE}/${HomestayRoomType.id}`,
        baseURL: Config.API_HOMESTAY,
        parser: dataItemParser,
    }).put({ RoomType: HomestayRoomType.export() }) :
        new ApiService({
            endpoint: Urls.HOMESTAY_ROOM_TYPE_CREATE,
            baseURL: Config.API_HOMESTAY,
            parser: dataItemParser,
        }).post({ RoomType: HomestayRoomType })
}

export function createHomestayRoomTypeTranslate(HomestayRoomType) {
    const roomTpye = HomestayRoomType.export(true).translate()
    roomTpye.roomTypeId = roomTpye.homestayRoomTypeId
    delete roomTpye.homestayRoomTypeId
    return new ApiService({
        baseURL: Config.API_HOMESTAY,
        endpoint: Urls.HOMESTAY_ROOM_TYPE_TRANSLATE_CREATE,
    }).post({...roomTpye});
}

export function updateHomestayRoomTypeTranslate(HomestayRoomType) {
    const roomTpye = HomestayRoomType.export(true).translate()
    roomTpye.roomTypeId = roomTpye.homestayRoomTypeId
    delete roomTpye.homestayRoomTypeId
    return new ApiService({
        baseURL: Config.API_HOMESTAY,
        endpoint: Urls.HOMESTAY_ROOM_TYPE_TRANSLATE_UPDATE,
    }).put({...roomTpye});
}

export function deleteHomestayRoomTypeTranslate(id) {
    return new ApiService({
        baseURL: Config.API_HOMESTAY,
        endpoint: Urls.HOMESTAY_ROOM_TYPE_TRANSLATE_DELETE,
        endpointParams: { id },
    }).delete();
}

export function getHomestayRoomTypeAllByHotel(id) {
    return new ApiService({
        endpoint: Urls.HOMESTAY_ROOM_TYPE_ALL_BY_HOTEL,
        baseURL: Config.API_HOMESTAY,
        endpointParams: {id},
    }).get();
}

const dataParser = (data) => ({
    dataList: (data.roomtypes || []).map(item => new HomestayRoomType(item)),
    pageIndex: Math.floor(data.offset / data.limit) + 1,
    pageSize: data.limit,
    totalCount: data.total,
});
const dataItemParser = (data) => new HomestayRoomType(data);
const dataItemParserDetail = (result) => new HomestayRoomType(result.roomtype || {});


